// import Datetime from '../../libs/vue-datetime/index.js'
export default {
    name: "addAunt",
    data: function() {
        return {
            isMiniProgram: this.$isMiniProgram(), //是否小程序环境
            isAPP: false, //是否APP环境
            servantId: this.$route.query.servantId,
            //平台: 0:用户端(排除),2:客户经理端,3:服务师端(默认)
            platform: this.$route.query.platform ? parseInt(this.$route.query.platform) : 3,
            //上一页面: 0:不确认,1:用户端服务师列表(排除),2:客户经理端服务师列表,3:服务师端首页(默认)
            fromPage: this.$route.query.fromPage ? parseInt(this.$route.query.fromPage) : 3,
            tab: "info",
            existed: false,
            existState: 0,
            info: {
                Birthday: "",
                ListServantPicture: [], //身份证件
                IdCardNo: "", //身份证号码
                ServiceContent: "", //服务内容id,以[,]分隔
                ServiceContentStr: "", //服务内容名称,以[/]分隔
            },
            isLoaded: false, //是否加载完数据
            ////==== 基本信息
            sexList: [ //性别
                [
                    {
                        id: 1,
                        value: "男",
                        parentId: 0,
                    },
                    {
                        id: 2,
                        value: "女",
                        parentId: 0,
                    },
                ]
            ],
            educationList: [], //学历
            marriageList: [], //婚姻状态
            zodiacList: [], //属相
            dateList: [[],[],[]], //生日
            sex: { //性别
                id: 0,
                value: "未设置",
                parentId: 0,
            },
            zodiac: { //属相
                id: 0,
                value: "未设置",
                parentId: 0,
            },
            birthday: { //生日
                id: 0,
                value: "未设置",
                parentId: 0,
            },
            education: { //学历
                id: 0,
                value: "未设置",
                parentId: 0,
            },
            marital: { //婚姻状态
                id: 0,
                value: "未设置",
                parentId: 0,
            },

            ////==== 身份证件
            certifyList: [], //证书
            selectCertify: {},
            curCertify: {}, //当前要上传照片的证书
            isShowCertifyPagePanel: false, //是否显示身份证件page面板
            defaultPhoto: require("../../assets/images/i_logo_hollow_white.png"),
            iconCamera: require("../../assets/images/i_camera_white.png"),

            ////==== 工作类型
            isShowWorktypePagePanel: false, //是否显示工作类型page面板
            isShowWorktypePanel: false, //是否显示选择工作类型面板
            curWorktypeList: [], //当前选中工作类型列表
            worktypeMaxNum: 6, //工作类型最大数量
            isShowServicetypePanel: false, //是否显示服务类型面板
            serviceType: [ //服务内容
                {
                    id: 0,
                    value: ""
                }
            ],
            serviceValues: "", //服务内容输出显示

            //日历组件
            // minDatetime: "1960-01-01T00:00:00",
            // maxDatetime: "2018-07-20T00:00:00", //最大可选日期
            // effectiveStep: 365, //有效时间段,单位: day
            // isOpenCalendar: false, //是否打开日历面板
            // isFullPage: false, //main是否全屏

            isClearField: false, //是否清空field数据
            isShowChooseImagePanel: false, //是否显示选择照片面板
            curTargetImage: "", //当前修改照片目标
            curTargetOptions: { //当前修改照片参数 - 身份证件
                index: 0, //索引
                side: 1, //1:正面, 2:反面
            },
            iosSelectRelation: [1], //IOS滚轮选择器联动控制
            iosSelectLevel: 1, //IOS滚轮选择器层级
            iosSelectBindType: 1, //IOS滚轮选择器绑定数据形式: 1:数组(通过parentId关联), 2:方法(使用dom节点的data-属性)
            iosSelectSpeciallyType: 0, //IOS滚轮选择器指定类型: 0:无, 1:日期(年月日), 2:日期(年月日时分)
            iosSelectInitValue: "", //IOS滚轮选择器初始显示值
            iosSelectDataSet: [], //IOS滚轮选择器数据源
            iosSelectTargetObject: {}, //IOS滚轮选择器目标对象
            isShowIosSelectPanel: false, //是否显示IOS滚轮选择器面板

            testImg: "", //测试图片
        }
    },
    // components: {
    //     'datetime': Datetime
    // },
    mounted: function() {
        this.init();
    },
    watch: {
        '$route': function(to, from) {
            if (to && (to.name === 'addAunt' || to.name === 'serverProfile')) {
                this.init();
            }
        }
    },
    methods: {
        //上传照片 - 打开相机
        setTestImg() {
            let self = this;
            if (this.isMiniProgram) {
                this.$get("/auth/wechat/config", {
                    url: process.env.domainHost + "/serverProfile?platform=3&fromPage=3"
                }, function(res) {
                    if (res.Success) {
                        if (res.Result && res.Result.AppId) {
                            alert("请求签名成功：" + res.Result.AppId);
                            self.$miniProgram_ChooseImage(1, 3, 1, res.Result, function(res) {
                                let photo = res;
                                if (photo && photo.length > 0) {
                                    self.testImg = photo[0];
                                } else {
                                    self.$toast("选择照片失败");
                                }
                            });
                        }
                    } else {
                        self.$toast(res.Message);
                    }
                });
            } else {
                self.$toast("不是小程序环境");
            }
        },
        init() {
            this.isMiniProgram = this.$isMiniProgram();
            this.checkAPP();
            this.servantId = this.$route.query.servantId;
            this.platform = this.$route.query.platform ? parseInt(this.$route.query.platform) : 3;
            this.fromPage = this.$route.query.fromPage ? parseInt(this.$route.query.fromPage) : 3;
            this.tab = "info";
            this.existed = false;
            this.existState = 0;
            this.info = {
                Cellphone: "",
                ServantPhoto: "",
                Birthday: "",
                ListServantPicture: [],
                IdCardNo: "", //身份证号码
                ServantSkill: [],
                ServiceContent: "", //服务内容id,以[,]分隔
                ServiceContentStr: "", //服务内容名称,以[/]分隔
            };
            this.sex = { //性别
                id: 0,
                value: "未设置",
                parentId: 0,
            };
            this.zodiac = { //属相
                id: 0,
                value: "未设置",
                parentId: 0,
            };
            this.birthday = { //生日
                id: 0,
                value: "",
                parentId: 0,
            };
            this.education = { //学历
                id: 0,
                value: "未设置",
                parentId: 0,
            };
            this.marital = { //婚姻状态
                id: 0,
                value: "未设置",
                parentId: 0,
            };
            this.isLoaded = false;

            this.isShowCertifyPagePanel = false;
            this.isShowWorktypePagePanel = false;
            this.isShowWorktypePanel = false;
            this.curWorktypeList = [];
            this.isShowServicetypePanel = false;
            this.serviceType = [ //服务内容
                {
                    id: 0,
                    value: ""
                }
            ];
            this.serviceValues = ""; //服务内容输出显示
            
            this.isClearField = false;
            this.isShowChooseImagePanel = false;
            this.curTargetImage = "";
            this.curTargetOptions = { //当前修改照片参数 - 身份证件
                index: 0, //索引
                side: 1, //1:正面, 2:反面
            };
            this.iosSelectRelation = [1];
            this.iosSelectLevel = 1;
            this.iosSelectBindType = 1;
            this.iosSelectSpeciallyType = 0;
            this.iosSelectInitValue = "";
            this.iosSelectDataSet = [];
            this.iosSelectTargetObject = {};
            this.isShowIosSelectPanel = false;
            
            if (this.platform == 3 || (this.platform == 2 && this.servantId)) {
                this.getProfile();
            } else {
                this.getSelectList();
                this.initWorkTypeList();
                this.initServiceContentList();
                this.isLoaded = true;
            }
        },
        //获取个人信息
        getProfile() {
            let self = this;
            let _params = {};
            if(this.platform == 2 && this.servantId){
                _params.servantId = this.servantId;
            }
            this.$get("/servant/getservantdetail", _params, function(res) {
                if (res.Success) {
                    if (res.Result && res.Result.ServantId) {
                        //处理数据
                        self.info = res.Result;
                        if (!self.info.Birthday) {
                            self.info.Birthday = "";
                        } else {
                            self.info.Birthday = self.info.Birthday.split("T")[0];
                            if (self.info.Birthday == "0001-01-01") {
                                self.info.Birthday = "";
                            }
                        }
                        self.sex = { //性别
                            id: self.info.Sex,
                            value: self.info.SexStr,
                            parentId: 0,
                        };
                        self.zodiac = { //属相
                            id: self.info.ZodiacType,
                            value: self.info.ZodiacTypeStr,
                            parentId: 0,
                        };
                        self.birthday = { //生日
                            id: 0,
                            value: self.info.Birthday,
                            parentId: 0,
                        };
                        self.education = { //学历
                            id: self.info.Education,
                            value: self.info.EducationStr,
                            parentId: 0,
                        };
                        self.marital = { //婚姻状态
                            id: self.info.MaritalStatus,
                            value: self.info.MaritalStatusStr,
                            parentId: 0,
                        };

                        self.getSelectList();
                        self.initWorkTypeList();
                        self.initServiceContentList();
                    }
                } else {
                    self.$toast(res.Message);
                }
                self.isLoaded = true;
            });
        },


        //即时返回FieldValue
        watchField(fieldName, backFieldValue) {
            this.info[fieldName] = backFieldValue;
        },

        //打开选择照片面板
        openChooseImagePanel(paramTarget,fieldType,fieldIndex,fieldSide) { //修改目标，修改类型，目标索引，目标正反面
            if(fieldType && parseInt(fieldType) == 2){ //身份证件
                this.curTargetImage = fieldType + "";
                this.curTargetOptions.index = parseInt(fieldIndex);
                this.curTargetOptions.side = parseInt(fieldSide);
            } else { //头像
                this.curTargetImage = paramTarget;
            }
            this.isShowChooseImagePanel = true;
        },
        //选择照片来源
        chooseImageSource(sourceType,curTarget){
            let self = this;
            // let resolveTarget = curTarget.split(".");
            let newImageUrl = "";
            if(parseInt(sourceType) == 1){
                dsBridge.call("photo", {}, function(data) {
                    if(data){
                        newImageUrl = "data:image/jpeg;base64," + data;
                    }
                    if(self.curTargetImage == "2"){
                        if(self.curTargetOptions.side == 1){
                            self.info.ListServantPicture[self.curTargetOptions.index].PositivePhoto = JSON.parse(JSON.stringify(newImageUrl));
                        } else {
                            self.info.ListServantPicture[self.curTargetOptions.index].ReversePhoto = JSON.parse(JSON.stringify(newImageUrl));
                        }
                    } else {
                        self.info.ServantPhoto = newImageUrl;
                    }
                });
            } else if(parseInt(sourceType) == 2){
                dsBridge.call("camera", {}, function(data) {
                    newImageUrl = "data:image/jpeg;base64," + data;
                    if(self.curTargetImage == "2"){
                        if(self.curTargetOptions.side == 1){
                            self.info.ListServantPicture[self.curTargetOptions.index].PositivePhoto = JSON.parse(JSON.stringify(newImageUrl));
                        } else {
                            self.info.ListServantPicture[self.curTargetOptions.index].ReversePhoto = JSON.parse(JSON.stringify(newImageUrl));
                        }
                    } else {
                        self.info.ServantPhoto = newImageUrl;
                    }
                });
            }
        },
        //关闭选择照片面板
        closeChooseImagePanel() {
            this.isShowChooseImagePanel = false;
        },

        //打开IosSelect
        openIosSelect(paramRelation,paramTarget,paramDataSet,paramBindType,paramSpeciallyType) {
            let self = this;
            self.iosSelectLevel = parseInt(paramRelation);
            switch (self.iosSelectLevel){
                case 1:
                    self.iosSelectRelation = [1];
                    self.iosSelectInitValue = paramTarget.value;
                    self.iosSelectDataSet = JSON.parse(JSON.stringify(paramDataSet));
                    // self.iosSelectTargetObject = JSON.parse(JSON.stringify(paramTarget));
                    self.iosSelectTargetObject = paramTarget;
                    break;
                case 2:
                    self.iosSelectRelation = [1,1];
                    self.iosSelectInitValue = paramTarget.value;
                    self.iosSelectDataSet = JSON.parse(JSON.stringify(paramDataSet));
                    // self.iosSelectTargetObject = JSON.parse(JSON.stringify(paramTarget));
                    self.iosSelectTargetObject = paramTarget;
                    break;
                case 3:
                    self.iosSelectRelation = [1,1,1];
                    self.iosSelectInitValue = paramTarget.value;
                    self.iosSelectDataSet = JSON.parse(JSON.stringify(paramDataSet));
                    // self.iosSelectTargetObject = JSON.parse(JSON.stringify(paramTarget));
                    self.iosSelectTargetObject = paramTarget;
                    break;
                default:
                    self.iosSelectRelation = [1];
                    self.iosSelectInitValue = paramTarget.value;
                    self.iosSelectDataSet = JSON.parse(JSON.stringify(paramDataSet));
                    // self.iosSelectTargetObject = JSON.parse(JSON.stringify(paramTarget));
                    self.iosSelectTargetObject = paramTarget;
                    break;
            }
            if(paramBindType){
                self.iosSelectBindType = paramBindType;
                if(self.iosSelectBindType == 2 && (!self.iosSelectInitValue || self.iosSelectInitValue == "")){
                    self.iosSelectInitValue = "1970-1-1";
                }
            } else {
                self.iosSelectBindType = 1;
            }
            if(paramSpeciallyType){
                self.iosSelectSpeciallyType = paramSpeciallyType;
            } else {
                self.iosSelectSpeciallyType = 0;
            }
            this.isShowIosSelectPanel = true;
        },
        //IosSelect选择后回调设置
        resetIosSelect(paramsValues, paramsIds, targetObject) {
            if(this.iosSelectBindType == 2 && this.iosSelectSpeciallyType == 1){
                this.birthday.value = paramsIds.join("-");
            } else {
                if (paramsValues) {
                    targetObject.value = paramsValues.join("");
                } else {
                    targetObject.value = "";
                }
                if (paramsIds && paramsIds.length > 0) {
                    targetObject.id = parseInt(paramsIds[0]);
                } else {
                    targetObject.id = 0;
                }
            }
            this.closeIosSelect();
        },
        //关闭IosSelect
        closeIosSelect() {
            this.isShowIosSelectPanel = false;
        },
        ////////////////////////////


        //新增阿姨时检查账号有效性
        getServent: function(cellphone) {
            var _this = this;

            if (!cellphone) return;
            if (cellphone.length != 11) {
                _this.$toast('请输入11位手机号');
                return;
            }
            _this.existed = false;
            _this.existState = 0;

            this.$get("servant/queryifexist", {
                phone: cellphone
            }, function(res) {
                if (res.Success) {
                    if (res.Result && res.Result.IfExist) {
                        _this.existed = true;
                        _this.existState = res.Result.ExistState;
                        _this.info = res.Result.ServantInfo;
                        _this.info.ServantSkill = _this.info.ServantSkill || [];

                        _this.initWorkTypeList();
                    }

                } else {
                    _this.$toast(res.Message);
                }
            });
        },
        bind: function() {
            var _this = this;
            if (!this.existed) return;

            this.$post("/servant/binding", {
                    "ServantId": this.info.ServantId
                },
                function(res) {
                    if (res.Success) {
                        _this.$toast("调取成功");
                        _this.$router.go(-1);
                    } else {
                        _this.$toast(res.Message);
                    }
                }
            );
        },
        //获取数据列表
        getSelectList() {
            var _this = this;
            this.$get("query/getaddservantallset", function(res) {
                if (res.Success) {
                    // _this.marriageList = res.Result.ListMaritalStatus;
                    // _this.educationList = res.Result.ListServantEducation;
                    // _this.zodiacList = res.Result.ListZodiacType;
                    _this.zodiacList = [[]];
                    let zodiacList = res.Result.ListZodiacType;
                    if(zodiacList && zodiacList.length>0){
                        zodiacList.map(item => {
                            let newItem = {};
                            newItem.id = item.Key;
                            newItem.value = item.Name;
                            newItem.parentId = 0;
                            _this.zodiacList[0].push(newItem);
                        });
                    }
                    _this.educationList = [[]];
                    let educationList = res.Result.ListServantEducation;
                    if(educationList && educationList.length>0){
                        educationList.map(item => {
                            let newItem = {};
                            newItem.id = item.Key;
                            newItem.value = item.Name;
                            newItem.parentId = 0;
                            _this.educationList[0].push(newItem);
                        });
                    }
                    _this.marriageList = [[]];
                    let marriageList = res.Result.ListMaritalStatus;
                    if(marriageList && marriageList.length>0){
                        marriageList.map(item => {
                            let newItem = {};
                            newItem.id = item.Key;
                            newItem.value = item.Name;
                            newItem.parentId = 0;
                            _this.marriageList[0].push(newItem);
                        });
                    }

                    //身份证件
                    _this.certifyList = res.Result.ListCertificateType;
                    let originListServantPicture = JSON.parse(JSON.stringify(_this.info.ListServantPicture));
                    _this.info.ListServantPicture = [];
                    for(let i=0; i<_this.certifyList.length; i++){
                        let newServantPictureItem = {
                            CertificateType: _this.certifyList[i].Key,
                            CertificateTypeStr: _this.certifyList[i].Name,
                            IsDelete: false,
                            PositivePhoto: "",
                            ReversePhoto: "",
                            ServantPictureId: 0
                        };
                        _this.info.ListServantPicture.push(newServantPictureItem);
                    }
                    if(_this.info.ListServantPicture && _this.info.ListServantPicture.length>0){
                        _this.info.ListServantPicture.map((item,index) => {
                            if(originListServantPicture && originListServantPicture.length>0){
                                originListServantPicture.map(originItem => {
                                    if(originItem.CertificateType == item.CertificateType){
                                        // item = JSON.parse(JSON.stringify(originItem));
                                        _this.info.ListServantPicture.splice(index,1,JSON.parse(JSON.stringify(originItem)));
                                    }
                                });
                            }
                        });
                    }
                } else {
                    _this.$toast(res.Message);
                }
            });
        },
        //检测是否APP环境
        checkAPP() {
            let self = this;
            let isAPP = dsBridge.hasNativeMethod('photo');
            self.isAPP = isAPP;
        },
        //上传照片 - 打开相册
        spPhoto(uploadImage) {
            // let self = this;
            // if (this.isMiniProgram) {
            //     // self.$miniProgram_ChooseImage(1, 3, 1, function(res) {
            //     //     let photo = res;
            //     //     if (photo && photo.length > 0) {
            //     //         self.info.ServantPhoto = photo[0];
            //     //     } else {
            //     //         self.$toast("选择照片失败");
            //     //     }
            //     // });
            //     this.doChgPhoto(uploadImage);
            // } else {
            //     dsBridge.call("photo", {}, function(data) {
            //         self.info.ServantPhoto = "data:image/jpeg;base64," + data;
            //     });
            // }
            this.doChgPhoto(uploadImage);
        },
        //上传照片 - 打开相机
        spCamera(uploadImage) {
            // let self = this;
            // if (this.isMiniProgram) {
            //     // self.$miniProgram_ChooseImage(1, 3, 2, function(res) {
            //     //     let photo = res;
            //     //     if (photo && photo.length > 0) {
            //     //         self.info.ServantPhoto = photo[0];
            //     //     } else {
            //     //         self.$toast("拍照失败");
            //     //     }
            //     // });
            //     this.doChgPhoto(uploadImage);
            // } else {
            //     dsBridge.call("camera", {}, function(data) {
            //         self.info.ServantPhoto = "data:image/jpeg;base64," + data;
            //     });
            // }
            this.doChgPhoto(uploadImage);
        },
        //更改照片 - 上传组件返回
        doChgPhoto(uploadImage) {
            let self = this;
            if (uploadImage) {
                self.info.ServantPhoto = uploadImage.FilePath;
            }
        },
        //验证基本信息
        validateInfo() {
            let isPass = false;
            if (!this.$verifyPhone(this.info.Cellphone)) {
                this.$toast("请输入正确手机号！");
                isPass = false;
            } else if (!this.info.ServantName) {
                this.$toast("请输入姓名！");
                isPass = false;
            } else if (!this.info.NativePlace) {
                this.$toast("请输入籍贯！");
                isPass = false;
            } else if (!this.sex.value || this.sex.value == "") {
                this.$toast("请选择您的性别！");
                isPass = false;
            } else if (!this.birthday.value || this.birthday.value.split("T")[0] == "0001-01-01" || this.birthday.value == "") {
                this.$toast("请选择您的生日！");
                isPass = false;
            }
            // else if (!this.info.ServantPhoto) {
            //     this.$toast("请上传头像！");
            //     isPass = false;
            // }
            else {
                isPass = true;
            }
            return isPass;
        },



        ///////////=============== 身份证件 ================
        //身份证件page面板开关
        switchCertifyPagePanel(){
            this.isShowCertifyPagePanel = !this.isShowCertifyPagePanel;
        },
        //上传证件照
        chgCertify(paramObject, paramType, sourceType) { //证件，1正|2反面，1相册|2相机
            let self = this;
            if (self.isAPP) {
                if (paramType == 1) { //正面照
                    if (sourceType == 1) { //相册
                        dsBridge.call("photo", {}, function(data) {
                            paramObject.PositivePhoto = "data:image/jpeg;base64," + data;
                            // paramObject.ServantPictureId = 0;
                        });
                    } else { //相机
                        dsBridge.call("camera", {}, function(data) {
                            paramObject.PositivePhoto = "data:image/jpeg;base64," + data;
                            // paramObject.ServantPictureId = 0;
                        });
                    }
                } else if (paramType == 2) { //反面照
                    if (sourceType == 1) { //相册
                        dsBridge.call("photo", {}, function(data) {
                            paramObject.ReversePhoto = "data:image/jpeg;base64," + data;
                            // paramObject.ServantPictureId = 0;
                        });
                    } else { //相机
                        dsBridge.call("camera", {}, function(data) {
                            paramObject.ReversePhoto = "data:image/jpeg;base64," + data;
                            // paramObject.ServantPictureId = 0;
                        });
                    }
                }
            } else {
                this.curCertify = JSON.parse(JSON.stringify(paramObject));
                this.curCertify.side = paramType;
            }
        },
        //执行更改
        doChgCertify(uploadImage) {
            let self = this;
            if (uploadImage) {
                this.info.ListServantPicture = this.info.ListServantPicture || [];
                for (var i = 0; i < this.info.ListServantPicture.length; i++) {
                    if (this.info.ListServantPicture[i].CertificateType == this.curCertify.CertificateType) {
                        let newCertify = this.info.ListServantPicture[i];
                        if (this.curCertify.side == 1) { //正面照
                            newCertify.PositivePhoto = uploadImage.FilePath;
                        } else if (this.curCertify.side == 2) { //反面照
                            newCertify.ReversePhoto = uploadImage.FilePath;
                        }
                        // newCertify.ServantPictureId = 0;
                        this.info.ListServantPicture.splice(i, 1, newCertify);
                        break;
                    }
                }
            }
        },
        //验证身份证件
        validateCard() {
            let isPass = false;
            if (!this.info.ListServantPicture || !this.info.ListServantPicture.length) {
                isPass = false;
            } else if(!this.info.ListServantPicture[0].PositivePhoto || 
            this.info.ListServantPicture[0].PositivePhoto.length <= 0 ||
            !this.info.ListServantPicture[0].ReversePhoto || 
            this.info.ListServantPicture[0].ReversePhoto.length <= 0){
                isPass = false;
                this.$toast("请上传身份证正反面照！");
            } 
            // else if(!this.info.IdCardNo || this.info.IdCardNo == ""){
            //     isPass = false;
            //     this.$toast("请输入身份证号码！");
            // } 
            else {
                isPass = true;
            }
            return isPass;
        },




        ///////////=============== 工作类型 ================
        //工作类型page面板开关
        switchWorktypePagePanel(){
            this.isShowWorktypePagePanel = !this.isShowWorktypePagePanel;
        },
        //初始化工作类型选中状态
        initWorkTypeList() {
            let self = this;
            self.curWorktypeList = [];
            if (self.info.ServantSkill && self.info.ServantSkill.length > 0) {
                self.info.ServantSkill.map(item => {
                    let newItem = {
                        Key: item.JobType
                    };
                    self.curWorktypeList.push(newItem);
                });
            } else {
                let newItem = {
                    JobType: 0,
                    JobTypeStr: "",
                    ExpectedSalary: null,
                    WorkingYears: null,
                    IsDelete: false,
                };
                self.info.ServantSkill.push(newItem);
            }
        },
        //打开选择工作类型面板
        openWorktypePanel() {
            this.isShowWorktypePanel = true;
        },
        //选择工作类型
        chgWorkType(paramsList) {
            let self = this;
            self.curWorktypeList = [];
            let isEmpty = true; //是否无选中项
            paramsList.map(item => {
                if(item.selected){
                    isEmpty = false;
                    let newItem = {
                        Key: item.Key
                    }
                    self.curWorktypeList.push(newItem);
                }
                if (self.info.ServantSkill && self.info.ServantSkill.length > 0) {
                    let isExist = false; //是否已存在
                    for (let i = 0; i < self.info.ServantSkill.length; i++) {
                        if (self.info.ServantSkill[i].JobType == item.Key) {
                            isExist = true;
                            let curItem = JSON.parse(JSON.stringify(self.info.ServantSkill[i]));
                            if(item.selected){ //如果选中
                                curItem.IsDelete = false; //不删除
                                // if(item.Key == 1){ //临时保洁，固定薪资
                                //     curItem.ExpectedSalary = 30;
                                //     self.$refs.worktypetemporary.updateFieldValue(curItem.ExpectedSalary);
                                // }
                            } else {
                                curItem.IsDelete = true; //删除
                            }
                            self.info.ServantSkill.splice(i, 1, curItem);
                        }
                    }
                    if(!isExist && item.selected){
                        let newItem = {
                            JobType: item.Key,
                            JobTypeStr: item.categoryName,
                            ExpectedSalary: null,
                            WorkingYears: null,
                            IsDelete: false,
                        };
                        self.info.ServantSkill.push(newItem);
                    }
                } else {
                    if(item.selected){
                        let newItem = {
                            JobType: item.Key,
                            JobTypeStr: item.categoryName,
                            ExpectedSalary: null,
                            WorkingYears: null,
                            IsDelete: false,
                        };
                        // if(item.Key == 1){ //临时保洁，固定薪资
                        //     newItem.ExpectedSalary = 30;
                        //     self.$refs.worktypetemporary.updateFieldValue(newItem.ExpectedSalary);
                        // }
                        self.info.ServantSkill.push(newItem);
                    }
                }
            });
            if(isEmpty){ //如果无选中项，则追加一条空选项
                let newItem = {
                    JobType: 0,
                    JobTypeStr: "",
                    ExpectedSalary: null,
                    WorkingYears: null,
                    IsDelete: false,
                };
                self.info.ServantSkill.push(newItem);
            } else { //否则，过滤掉空选项
                for (let i = 0; i < self.info.ServantSkill.length; i++) {
                    if (self.info.ServantSkill[i].JobType == 0) {
                        self.info.ServantSkill.splice(i, 1);
                    }
                }
            }
        },
        //即时返回FieldValue - 薪资待遇
        watchFieldExpectedSalary(fieldName, backFieldValue) {
            let self = this;
            let resolveTarget = fieldName.split("_");
            self.info.ServantSkill[parseInt(resolveTarget[0])].ExpectedSalary = backFieldValue;
        },
        //即时返回FieldValue - 工作经验
        watchFieldWorkingYears(fieldName, backFieldValue) {
            let self = this;
            let resolveTarget = fieldName.split("_");
            self.info.ServantSkill[parseInt(resolveTarget[0])].WorkingYears = backFieldValue;
        },
        //关闭选择工作类型面板
        closeWorktypePanel() {
            this.isShowWorktypePanel = false;
        },
        //添加工作类型
        addNewWorktype(){
            let self = this;
            if(!self.info.ServantSkill || self.info.ServantSkill.length < self.worktypeMaxNum){
                let newItem = {
                    JobType: 0,
                    JobTypeStr: "",
                    ExpectedSalary: null,
                    WorkingYears: null,
                    IsDelete: false,
                };
                self.info.ServantSkill.push(newItem);
            } else {
                self.$toast("总共" + self.worktypeMaxNum + "个工作类型已经加完了");
                return false;
            }
        },

        //初始化服务内容
        initServiceContentList() {
            let self = this;
            self.serviceType = [];
            self.serviceValues = "";
            if(self.info.ServiceContent){
                let curSContList = self.info.ServiceContent.split(",");
                // let curScontValueList = self.info.ServiceContentStr.split("/");
                self.serviceValues = self.info.ServiceContentStr ? self.info.ServiceContentStr.replace(/\//g,' ') : "";
                curSContList.map((curItem,curIndex) => {
                    let newItem = {
                        id: parseInt(curItem),
                        value: "",//curScontValueList[curIndex]
                    };
                    self.serviceType.push(newItem);
                    // self.serviceValues += curScontValueList[curIndex];
                });
            } else {
                self.serviceType = [{
                    id: 0,
                    value: ""
                }];
                self.serviceValues = "";
            }
        },
        //打开选择服务内容面板
        openServicetypePanel() {
            this.isShowServicetypePanel = true;
        },
        //修改服务内容
        chgServicetype(paramsItems) {
            let self = this;
            self.serviceType = [];
            self.serviceValues = "";
            self.info.ServiceContent = "";
            if (paramsItems && paramsItems.length > 0) {
                paramsItems.map(item => {
                    let newItem = {};
                    newItem.id = item.SubCategoryId;
                    newItem.value = item.SubCategoryName;
                    self.serviceType.push(newItem);
                    self.serviceValues += newItem.value + " ";
                    self.info.ServiceContent = self.info.ServiceContent ? (self.info.ServiceContent + "," + item.SubCategoryId) : (item.SubCategoryId + "");
                });
            } else {
                let newItem = {
                    id: 0,
                    value: ""
                };
                self.serviceType.push(newItem);
            }
        },
        //关闭选择服务内容面板
        closeServicetypePanel() {
            this.isShowServicetypePanel = false;
        },
        //验证工作类型
        validateWorkType() {
            let isPass = false;
            if (!this.info.ServantSkill || this.info.ServantSkill.length <= 0) {
                this.$toast("请选择工作类型！");
                isPass = false;
            } else {
                let isRight = false;
                this.info.ServantSkill.map(item => {
                    if (!item.IsDelete && item.JobType != 0) {
                        isRight = true;
                    }
                });
                if (!isRight) {
                    this.$toast("请选择工作类型！");
                    isPass = false;
                } else {
                    isPass = true;
                }
            }
            return isPass;
        },

        //////////===========================
        //下一步
        nextStep(targetStep){
            switch (targetStep){
                case 2:
                    let isPass = this.validateInfo();
                    if (isPass) {
                        this.switchCertifyPagePanel();
                    } else {
                        return false;
                    }
                    break;
                case 3:
                    let isPass2 = this.validateCard();
                    if (isPass2) {
                        this.switchWorktypePagePanel();
                    } else {
                        return false;
                    }
                    break;
                case 4:
                    let isPass3 = this.validateWorkType();
                    if (isPass3) {
                        this.saveForm();
                    } else {
                        return false;
                    }
                    break;
                default:
                    break;
            }
        },
        //提交保存
        saveForm() {
            let self = this;
            let isPass = this.validateInfo();
            if (!isPass) {
                this.switchCertifyPagePanel();
                this.switchWorktypePagePanel();
                return false;
            }
            let isPass2 = this.validateCard();
            if (!isPass2) {
                this.switchWorktypePagePanel();
                return false;
            }
            let isPass3 = this.validateWorkType();
            if (!isPass3) {
                return false;
            }
            for (let i = 0; i < self.info.ServantSkill.length; i++) {
                if (self.info.ServantSkill[i].JobType == 0) {
                    self.info.ServantSkill.splice(i, 1);
                }
            }
            if (!self.info.ServantSkill || self.info.ServantSkill.length <= 0) {
                self.$toast("请选择工作类型！");
                return false;
            }
            this.info.Birthday = this.info.Birthday.split("T")[0];
            let info = this.info;
            
            info.Sex = this.sex.id;
            info.SexStr = this.sex.value;
            info.Education = this.education.id;
            info.ZodiacType = this.zodiac.id;
            info.Birthday = this.birthday.value;
            info.MaritalStatus = this.marital.id;
            // console.log(info.ServantSkill);
            let curApi = "/servant/createservant";
            if (this.platform == 3 || (this.platform == 2 && this.servantId)) {
                curApi = "/servant/editservant";
            }
            this.$post(curApi, {
                    "ServantInfo": info
                },
                function(res) {
                    if (res.Success) {
                        if (self.platform == 3 || (this.platform == 2 && this.servantId)) {
                            self.$toast("保存成功");
                        } else {
                            self.$toast("创建成功");
                            self.isClearField = true;
                            self.$router.go(-1);
                        }
                    } else {
                        self.$toast(res.Message);
                    }
                }
            );
        },

        //自定义返回
        customBack() {
            this.isClearField = true;
            this.$router.go(-1);
        },
    },
    beforeDestroy() {
        this.isClearField = true;
    },
}


// WEBPACK FOOTER //
// ./src/shared/components/server/server-profile-new.js